














































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { DateRange } from "vuetify-daterange-picker";
import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css";

import { IMapLayer, IMapFilter, ICodeList } from "@/components/map/types";
import { IIconMenu } from "@/components/shared/types";
import { User } from "@/components/User";
import Map from "@/components/map/Map";

import { isObject, createDate, 
         DateOfNDaysBefore, DateOfNMonthsBefore } from "@/common/utils";
import { L, D, DT } from "@/common/filters";

const TODAY = new Date(); TODAY.setHours(23,59,59,999);
const THIS_DATE = TODAY.toISOString().substr(0,10);
const LAST_7DAYS = DateOfNDaysBefore(7,TODAY);
const LAST_1MONTH = DateOfNMonthsBefore(1,TODAY);
const LAST_3MONTHS = DateOfNMonthsBefore(3,TODAY);
const LAST_1YEAR = DateOfNMonthsBefore(12,TODAY);

const API_URL = 'https://apicmet.gistda.or.th/main/data/hasdisease';

const MAP_EXTENT: [number,number,number,number] = [95.854, 5.299, 106.064, 20.533];
const CROPS = {
  rice: { th: 'ข้าว', en: 'Rice', zh: '水稻' },
  cassava: { th: 'มันสำปะหลัง', en: 'Cassava', zh: '木薯' },
  maize: { th: 'ข้าวโพด', en: 'Maize', zh: '玉米' },
  sugarcane: { th: 'อ้อยโรงงาน', en: 'Sugarcane', zh: '甘蔗' },
  longan: { th: 'ลำไย', en: 'Longan', zh: '龙眼' },
  all: { th: 'พืชทั้งหมด', en: 'All Crops', zh: '所有农作物' }
}
const DISEASES_MENU:IIconMenu[] = [{
    name: 'rice',
    title: 'ข้าว',
    submenus: [{
      id: 1,
      name: 'rice',
      title: 'เพลี้ยกระโดดสีน้ำตาล'
    }]
  },{
    name: 'cassava',
    title: 'มันสำปะหลัง',
    submenus: [{
      id: 2,
      name: 'cassava',
      title: 'เพลี้ยแป้งมันสำปะหลังสีชมพู'
    }]
  },{
    name: 'maize',
    title: 'ข้าวโพด',
    submenus: [{
      id: 3,
      name: 'maize',
      title: 'หนอนเจาะลำต้นข้าวโพด'
    }]
  },{
    name: 'sugarcane',
    title: 'อ้อยโรงงาน',
    submenus: [{
      id: 4,
      name: 'sugarcane',
      title: 'หนอนกออ้อยลายจุดเล็ก'
    }]
  },{
    name: 'longan',
    title: 'ลำไย',
    submenus: [{
      id: 5,
      name: 'longan',
      title: 'เพลี้ยแป้งมันสำปะหลังสีชมพู'
    }]
  },{
    name: 'all',
    title: 'พืชทั้งหมด',
    submenus: [{
      id: 0,
      name: 'all',
      title: 'โรคพืชทั้งหมด'
    }]
  }];

interface IChartSeries {
  name?: string;
  data?: {[key:string] : number };
  color?: string;
}

interface IChartData {
  /*SourceName?: string;
  StationName?: string;
  Latitude?: number;
  Longitude?: number;*/
  StartDatetime?: string;
  EndDatetime?: string;
  MeasureType?: string;
  MeasureUnit?: string;
  AvgValue?: number;
  MinValue?: number;
  MaxValue?: number;
}

interface IChart {
  Definition?: {[key:string] : any};
  Data?: IChartData[];
  Min?: number; // Min of all values
  Max?: number; // Max of all values;
  Series?: IChartSeries[]; // contains Min/Max/Avg observed value of a MeasureType
  XTitle?: string;
  YTitle?: string;
  Visible?:boolean;  // used to control visibility of chart
}

@Component({
  components: {
    'v-daterange': DateRange
  }
})
export default class DiseaseCharts extends Vue {
  @Prop({
    default: null
  }) data: {
    $map: Map;
    mapLayers: IMapLayer[];
    mapFilter: IMapFilter;
  };
  Crops = CROPS;

  $map: Map;
  layers: IMapLayer[];
  area: IMapFilter = {
    ProvinceCode: null,
    AmphoeCode: null,
    TambonCode: null
  };
  selectedProvinceCode: null;
  selectedAmphoeCode: null;
  selectedTambonCode: null;

  showArea: boolean = false;
  Provinces: ICodeList[] = [];
  Amphoes: ICodeList[] = [];
  Tambons: ICodeList[] = [];

  menuDiseases:IIconMenu[] = DISEASES_MENU;
  showDiseasesMenu:boolean = false;
  showDateRange: boolean = false;
  dateRange: [Date,Date] = [LAST_7DAYS, DateOfNDaysBefore(-7,LAST_7DAYS)];

  // start with all diseases
  selectedCrop:string = 'all';
  selectedPests:string = 'โรคพืชทั้งหมด';
  selectedDiseaseId:number = 0;

  chartTemporature:IChart = {
    Definition: {},
    XTitle: 'อุณหถูมิเฉลี่ย',
    YTitle: 'องศาเซลเซียส'
  };
  chartHumidity:IChart = {
    Definition: {},
    XTitle: 'ความชื้นสัมพัทธ์เฉลี่ย',
    YTitle: 'เปอร์เซ็นต์'
  };
  chartRainfall:IChart = {
    Definition: {},
    XTitle: 'ปริมาณน้ำฝนเฉลี่ย',
    YTitle: 'มิลลิเมตร (mm)'
  };
  chartDailyDiseases:IChart = {
    Definition: {},
    XTitle: 'การเกิดโรคพืชในแต่ละวัน',
    YTitle: 'จำนวนพื้นที่เฝ้าระวัง (ตร.กม.)'
  };
  chartDailyDiseasesByArea:IChart = {
    Definition: {},
    XTitle: 'การเกิดโรคพืชในแต่ละพื้นที่เฝ้าระวัง',
    YTitle: 'จำนวนพื้นที่เฝ้าระวัง (ตร.กม.)'
  };
  chartOptions = {
    title: {
      fontSize: 15,
      fontStyle: 'normal'
    },
    scales: {
      yAxes: [{
        scaleLabel: {
          fontSize: 13,
          fontStyle: 'normal'
        }
      }]
    }
  };

  fetchingData: boolean = false;
  hasDiseases:boolean = false;
  errorMessage: string = null;

  get User() : User {
    return this.$store.getters.User;
  };

  get language() : string {
    return this.User.Language;
  };

  get locale() : string {
    let lang = this.language;
    return lang=='th' ? 'th-th' : lang=='zh' ? 'zh-cn' : 'en-us';
  }

  get ChartTitle() : string {
    let s:string = this.selectedPests;
    let sd = this.dateRange[0].toISOString().substr(0,10);
    let ed = this.dateRange[1].toISOString().substr(0,10);
    if (sd==ed) {
      s += 'ในวันที่ ' + D(this.dateRange[0], 'dd MMM yyyy');
    } else {
      s += 'ระหว่างวันที่ ' + D(this.dateRange[0], 'dd MMM yyyy') + ' และ ' + D(this.dateRange[1], 'dd MMM yyyy');
    }
    let i, n, an = '';
    if (this.area.ProvinceCode) {
      for (i=0; i<this.Provinces.length; i++) {
        if (this.Provinces[i].code==this.area.ProvinceCode) {
          //an = this.language=='th' ? this.Provinces[i].name : this.Provinces[i].name_en;
          an = this.Provinces[i].name
          if (this.area.ProvinceCode!=10) {
            an = 'จ.' + an;
          }
          break;
        }
      }
      if (this.area.AmphoeCode) {
        for (i=0; i<this.Amphoes.length; i++) {
          if (this.Amphoes[i].code==this.area.AmphoeCode) {
            //n = this.language=='th' ? this.Amphoes[i].name : this.Amphoes[i].name_en;
            n = this.Amphoes[i].name
            if (this.area.ProvinceCode!=10) {
              an = 'อ.' + n + ' ' + an;
            } else {
              an = 'เขต' + n + ' ' + an;
            }
          }
        }
        if (this.area.TambonCode) {
          for (i=0; i<this.Tambons.length; i++) {
            if (this.Tambons[i].code==this.area.TambonCode) {
              //n = this.language=='th' ? this.Tambons[i].name : this.Tambons[i].name_en;
              n = this.Tambons[i].name
              if (this.area.ProvinceCode!=10) {
                an = 'ต.' + n + ' ' + an;
              } else {
                an = 'แขวง' + n + ' ' + an;
              }
            }
          }
        }
      }
      s += ' ใน' + an;
    }
    return s;
  }
  
  dateRangeOptions = {
    maxDate: TODAY.toISOString().substr(0,10),
    startDate: LAST_7DAYS.toISOString().substr(0,10),
    endDate: DateOfNDaysBefore(-7,LAST_7DAYS).toISOString().substr(0,10),
    format: this.language=='th' ? 'DD/MM/YYYY' : this.language=='zh' ? 'YYYY/MM/DD' : 'MM/DD/YYYY',
    presets: [{
        label: L('nDaysAgo',[7]),
        range: [
          LAST_7DAYS.toISOString().substr(0,10), //start date. YYYY-MM-DD
          DateOfNDaysBefore(-7,LAST_7DAYS).toISOString().substr(0,10) // end date. YYYY-MM-DD
        ]
      },{
        label: L('oneMonthAgo'),
        range: [
          LAST_1MONTH.toISOString().substr(0,10), //start date. YYYY-MM-DD
          DateOfNDaysBefore(-7,LAST_1MONTH).toISOString().substr(0,10) // end date. YYYY-MM-DD
        ]
      },{
        label: L('nMonthsAgo',[3]),
        range: [
          LAST_3MONTHS.toISOString().substr(0,10), //start date. YYYY-MM-DD
          DateOfNDaysBefore(-7,LAST_3MONTHS).toISOString().substr(0,10) // end date. YYYY-MM-DD
        ]
      },{
        label: L('oneYearAgo'),
        range: [
          LAST_1YEAR.toISOString().substr(0,10), //start date. YYYY-MM-DD
          DateOfNDaysBefore(-7,LAST_1YEAR).toISOString().substr(0,10) // end date. YYYY-MM-DD
        ]
      }]
  };

  dateRangeLabels = {
    start: L('startDate'),
    end: L('endDate'),
    presets: ''
  };

  created() {
    this.Backdrop = false;
    this.fetchProvinces();
    if (this.data) {
      this.$map = this.data.$map;
      this.layers = this.data.mapLayers;
      ['ProvinceCode', 'AmphoeCode', 'TambonCode'].forEach((code) => {
        this.area[code] = this['selected' + code] = this.data.mapFilter[code];
      });
      if (this.area.ProvinceCode) {
        this.fetchAmphoes();
        if (this.area.AmphoeCode) {
          this.fetchTambons();
        }
      }
    }
  }

  mounted() {
    this.fetchDiseasesData();
  }

  initializeLabels() {
    let pLabels = [
      ['nDaysAgo',7],
      ['oneMonthAgo'],
      ['nMonthsAgo',3],
      ['oneYearAgo']
    ];
    this.dateRangeOptions.presets.forEach((p,i) => {
      if (pLabels[i].length==1) {
        p.label = L(pLabels[i][0]);
      } else {
        p.label = L(pLabels[i][0],[pLabels[i][1]]);
      }
    });
    this.dateRangeLabels.start = L('startDate')
    this.dateRangeLabels.end = L('endDate');
  }

  doSelectDisease(menu:IIconMenu) {
    this.showDiseasesMenu = false;
    this.selectedCrop = menu.name;
    this.selectedPests = menu.title;
    this.selectedDiseaseId = menu.id;
    this.fetchDiseasesData();
  }

  lastStartDate:string;
  onDateRangeChange(range) {
    let dr:any = this.$refs["DateRange"];
    if (dr.startDate!=this.lastStartDate) {
      this.lastStartDate = dr.startDate;
      let ed = DateOfNDaysBefore(-7, createDate(this.lastStartDate)); // 7 days after..
      if (ed.getTime() > TODAY.getTime()) {
        ed = TODAY
      }
      dr.endDate = ed.toISOString().substr(0,10);
      this.dateRangeOptions.maxDate = dr.endDate;
    }
  }

  get Backdrop() : boolean {
    return this.$store.getters.ShowBackdrop;
  }
  
  lastDateRange:string[] = null; //used to rollback in case that date range is cancelled
  set Backdrop(show:boolean) {
    if (show) {
      let dr:any = this.$refs["DateRange"];
      this.lastDateRange = [
        dr.startDate, dr.endDate
      ];
      this.lastStartDate = dr.startDate;
      this.initializeLabels();
    }
    this.$store.commit('notifyChange', {
      ShowBackdrop: show
    });
  }

  setDateRange() {
    let dr:any = this.$refs["DateRange"];
    this.dateRange = [createDate(dr.startDate), createDate(dr.endDate)];
    this.Backdrop = false;
    this.showDateRange = false;
    this.fetchDiseasesData();
  }

  cancelDateRange() {
    let dr:any = this.$refs["DateRange"];
    dr.startDate = this.lastDateRange[0];
    dr.endDate = this.lastDateRange[1];
    this.Backdrop = false;
    this.showDateRange = false;
  }

  setArea() {
    this.showArea = false;
    this.area.ProvinceCode = this.selectedProvinceCode;
    this.area.AmphoeCode = this.selectedAmphoeCode;
    this.area.TambonCode = this.selectedTambonCode;
    this.zoomToTambon();
    this.fetchDiseasesData();
  }

  cancelArea() {
    this.showArea = false;
  }

  refreshDiseasesMap() {
    let layer:IMapLayer;
    this.layers.forEach((ml) => {
      if (ml.id==this.selectedDiseaseId+'') {
        ml.visible = true;
        ml.checked = true;
        ml.mapSources.forEach((ms) => {
          if (ms.nativeLayer) {
            ms.visible = true;
            ms.nativeLayer.setVisible(true);
            let source = ms.nativeLayer.getSource();
            let params = source['getParams'] ? source['getParams']() : {};
            let yyyymmdd = this.dateRange[0].toISOString().substr(0,10);
            if (this.selectedDiseaseId===0) {
              params = Object.assign({}, params, {
                VIEWPARAMS:'Date:' + yyyymmdd
              });
            } else {
              params = Object.assign({}, params, {
                VIEWPARAMS:'DiseaseID:' + ml.id + ';Date:' + yyyymmdd
              });
            }
            if (source['updateParams']) {
              source['updateParams'](params);
            }
          }
        });
      } else {
        ml.mapSources.forEach((ms) => {
          if (ms.nativeLayer) {
            ms.visible = false;
            ms.nativeLayer.setVisible(false);
          }
        });
        ml.visible = false;
        ml.checked = false;
      }
    });
    this.$emit('changeMe',{
      menu: {
        name: 'update_visible_layers'
      }
    });
  }

  async fetchDiseasesData() {
    this.refreshDiseasesMap();
    let url;
    try {
      url = API_URL;
      this.errorMessage = null;
      this.hasDiseases = false;
      this.fetchingData = true;
      let data = await this.User.requestResource(url, 'GET', {
        DiseaseID: this.selectedDiseaseId
      });
      this.hasDiseases = !!data;
      this.fetchingData = false;
    } catch (error) {
      //this.errorMessage = url + ' : ' + (error.message || 'Unknown Error');
      this.fetchingData = false;
    }
  }

  async fetchProvinces() {
    try {
      let data = await this.User.requestResource('codelist/province');
      this.Provinces = data.map((d) => {
        return d;
      });
    } catch (error) {
    }
  }
  
  async fetchAmphoes() {
    try {
      this.Amphoes = [];
      this.Tambons = [];
      if (!this.selectedProvinceCode) {
        this.selectedAmphoeCode = null;
      } else {
        let rest = 'codelist/amphoe/' + this.selectedProvinceCode;
        let data = await this.User.requestResource(rest);
        this.Amphoes = data.map((d) => {
          return d;
        });
      }
    } catch (error) {
    }
  };

  async fetchTambons() {
    try {
      this.Tambons = [];
      if (!this.selectedAmphoeCode) {
        this.selectedTambonCode = null;
      } else {
        let rest = 'codelist/tambon/' + this.selectedAmphoeCode;
        let data = await this.User.requestResource(rest);
        this.Tambons = data.map((d) => {
          return d;
        });
      }
    } catch (error) {
    }
  }
  
  onProvinceChange() {
    this.fetchAmphoes();
  }

  onAmphoeChange() {
    this.fetchTambons();
  }

  async zoomToProvince() {
    try {
      if (!this.area.ProvinceCode) {
        this.$map.clearAoi();
        this.$map.MapExtent = MAP_EXTENT;
      } else {
        let province:ICodeList;
        this.Provinces.forEach((p) => {
          if (p.code==this.area.ProvinceCode) {
            province = p;
            return;
          }
        });
        if (!province.feature) {
          let url, bbox;
          try {
            url = 'gis/bbox/province/' + this.area.ProvinceCode + '?crs=3857';
            bbox = await this.User.requestResource(url);
            //this.$map.changeMapView('zoomToExtent',{extent:[bbox.xmin,bbox.ymin,bbox.xmax,bbox.ymax]});
            this.$map.MapExtent = [bbox.xmin,bbox.ymin,bbox.xmax,bbox.ymax];
          } catch (be) {
            bbox = null;
          }
          url = 'gis/province/' + this.area.ProvinceCode + '?crs=3857';
          province.feature = await this.User.requestResource(url);
          province.feature = this.$map.GeoJSONToFeatures(province.feature);
          this.$map.addFeaturesToLayer(province.feature, "AoiLayer", {
            zoomTo: !bbox
          });
        } else {
          this.$map.addFeaturesToLayer(province.feature, "AoiLayer");
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async zoomToAmphoe() {
    try {
      if (!this.area.AmphoeCode) {
        this.zoomToProvince();
      } else {
        let amphoe:ICodeList;
        this.Amphoes.forEach((a) => {
          if (a.code==this.area.AmphoeCode) {
            amphoe = a;
            return;
          }
        });
        if (!amphoe.feature) {
          let url, bbox;
          try {
            url = 'gis/bbox/amphoe/' + this.area.AmphoeCode + '?crs=3857';
            bbox = await this.User.requestResource(url);
            this.$map.MapExtent = [bbox.xmin,bbox.ymin,bbox.xmax,bbox.ymax];
          } catch (be) {
            bbox = null;
          }
          url = 'gis/amphoe/' + this.area.AmphoeCode + '?crs=3857';
          amphoe.feature = await this.User.requestResource(url);
          amphoe.feature = this.$map.GeoJSONToFeatures(amphoe.feature);
          this.$map.addFeaturesToLayer(amphoe.feature, "AoiLayer", {
            zoomTo: !bbox
          });
        } else {
          this.$map.addFeaturesToLayer(amphoe.feature, "AoiLayer");
        }
      }
    } catch (error) {
    }
  }

  async zoomToTambon() {
    try {
      if (!this.area.TambonCode) {
        this.zoomToAmphoe();
      } else {
        let tambon:ICodeList;
        this.Tambons.forEach((t) => {
          if (t.code==this.area.TambonCode) {
            tambon = t;
            return;
          }
        });
        if (!tambon.feature) {
          let rsc = 'gis/tambon/' + this.area.TambonCode + '?crs=3857';
          tambon.feature = await this.User.requestResource(rsc);
          tambon.feature = this.$map.GeoJSONToFeatures(tambon.feature);
        }
        this.$map.addFeaturesToLayer(tambon.feature, "AoiLayer");
      }
    } catch (error) {
    }
  }

  clearSelectedArea(code:string) {
    code = code || 'ProvinceCode';
    this['selected' + code] = null;
  }

  closeMe() {
    this.$emit('closeRightToc');
  }
  
  letItHover() {
    //just make menu hover but do nothing
  }
}
